import { forwardRef } from 'react';
import { Box } from '@material-ui/core';

import styled from 'hooks/styled';

const Root = styled(Box, {
  label: 'Space',
  ignore: ['fullWidth', 'gap'],
})(({ theme, gap, fullWidth }) => ({
  display: fullWidth ? 'flex' : 'inline-flex',
  gap: theme.spacing(gap),
}));

const Space = forwardRef((props, ref) => {
  const {
    gap = 1,
    fullWidth,
    alignItems = 'center',
    direction = 'row',
    className,
    ...rest
  } = props;

  return (
    <Root
      gap={gap}
      fullWidth={fullWidth}
      alignItems={alignItems}
      flexDirection={direction}
      className={className}
      ref={ref}
      {...rest}
    />
  );
});

export default Space;
